import React, { useCallback, useContext, useState } from "react";

type MenuMovilCategorieConstextType = {
  MenuMovil?: boolean;
  HeaddleActiveMenu: (activeMenu: boolean) => void;
};

export const MovilCategoriesContext = React.createContext<
  MenuMovilCategorieConstextType | undefined
>(undefined);

const ContextMovilCategorieProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [MenuMovil, setMenuMovil] = useState<boolean>(false);

  const HeaddleActiveMenu = useCallback((activeMenu: boolean) => {
    setMenuMovil(activeMenu);
  }, []);

  return (
    <MovilCategoriesContext.Provider
      value={{
        MenuMovil,
        HeaddleActiveMenu,
      }}>
      {children}
    </MovilCategoriesContext.Provider>
  );
};

export default ContextMovilCategorieProvider;

export const useConatextMovilCategoriesData = () => {
  const context = useContext(MovilCategoriesContext);
  if (!context)
    throw new Error(
      "useConatextCategoriesData must be used within a ContextMovilCategorieProvider"
    );

  return context;
};
